export default __webpack_public_path__ + "static/media/item3@2x.38773301.png";